import axios from '../util/axios';
import Token from '../util/Token';

const BASE_URL = '/cms/v1/team';

// Get station uptime data
async function getStationUptime(teamId, params = {}) {
  try {
    Token.setAuthToken();
    const requestParams = {
      includeDetails: true,
      statusFilter: 'all',
      ...params
    };
    
    const response = await axios.get(`${BASE_URL}/${teamId}/station-uptime`, {
      params: requestParams
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching station uptime data:', error);
    throw error;
  }
}

// Get station uptime for a specific station
async function getStationUptimeDetails(teamId, stationId, params = {}) {
  try {
    Token.setAuthToken();
    const response = await axios.get(`${BASE_URL}/${teamId}/station-uptime/${stationId}`, {
      params: {
        ...params
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching station uptime details:', error);
    throw error;
  }
}

const stationUptimeService = {
  getStationUptime,
  getStationUptimeDetails
};

export default stationUptimeService;
